import React from 'react';
import { Dialog, Button, FormGroup, InputGroup, Intent, Callout, Classes, Toaster, Position } from "@blueprintjs/core";
import Validator from 'validator';

import Auth from '../../services/Auth';

import SignUpPanel from './SignUpPanel';

const btnSignUpStyle = {
    marginTop: '30px'
}

class SignInPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            submiting: false
        }
    }

    handleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        this.setState({
            [name]: value
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ submitError: null, submiting: true });
        Auth.login(this.state)
            .then(() => this.props.onSignInSuccess())
            .catch((e) => {
                const { code } = e;

                switch (code) {
                    case 'auth/wrong-password':
                        this.setState({ submitError: 'Invalid password', submiting: false })
                        break;
                    case 'auth/user-not-found':
                        this.setState({ submitError: 'We did not found account associated with this email', submiting: false })
                        break;
                    case 'auth/user-disabled':
                        this.setState({ submitError: 'Your account is disabled. Please contact support for more information.', submiting: false })
                        break;
                    default:
                        this.setState({ submitError: e.message, submiting: false });
                        return;
                }
            })
    }

    render() {
        const { email, password, submitError } = this.state;

        const isEnabled =
            email.length > 0 &&
            Validator.isEmail(email) &&
            password.length > 0;
        const intentEmail = email === '' ? Intent.NONE : (Validator.isEmail(email) ? Intent.NONE : Intent.DANGER);

        return (
            <form onSubmit={this.handleSubmit}>
                {submitError != null &&
                    <Callout
                        title="Oups..."
                        intent={Intent.DANGER}>
                        {submitError}
                    </Callout>
                }
                <FormGroup
                    labelFor="username"
                    intent={intentEmail}
                    helperText={(email !== '' && !Validator.isEmail(email)) && 'Not valid email'} >
                    <InputGroup
                        large={true}
                        leftIcon="envelope"
                        placeholder="Email"
                        name="email"
                        id="email"
                        intent={intentEmail}
                        onChange={this.handleInputChange} />
                </FormGroup>
                <FormGroup labelFor="password">
                    <InputGroup
                        type="password"
                        large={true}
                        leftIcon="lock"
                        placeholder="Password"
                        name="password"
                        id="password"
                        onChange={this.handleInputChange} />
                </FormGroup>
                <Button
                    type="submit"
                    text="Login"
                    fill={true}
                    disabled={!isEnabled}
                    loading={this.state.submiting} />
                <RecoverPassword />
                <Button
                    style={btnSignUpStyle}
                    intent={Intent.PRIMARY}
                    onClick={this.openSignUpPanel}
                    text="Subscribe"
                    fill={true} />
            </form>
        );
    }

    openSignUpPanel = () => {
        const panelNumber = this.props.panelNumber + 1;

        this.props.openPanel({
            component: SignUpPanel,
            props: { panelNumber },
            title: 'Inscription'
        })
    }
}

class RecoverPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = { modalIsOpen: false, email: '' }
    }

    handleChangeInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        this.setState({ [name]: value });
    }
    handleSubmitRecoverPassword = () => {
        const { email } = this.state;

        Auth.resetPassword(email)
            .then(() => this.toaster.show({
                message: 'An email has been sent to you!',
                icon: 'inbox',
                intent: Intent.PRIMARY
            }))
            .then(() => this.handleCloseDialog())
            .catch((e) => {
                const { code } = e;

                switch (code) {
                    case 'auth/user-not-found':
                        return (this.toaster.show({
                            message: 'This address is not associated with an account.',
                            intent: Intent.DANGER
                        }));
                    case 'auth/invalid-email':
                        return (this.toaster.show({
                            message: 'Please enter valid email address.',
                            intent: Intent.DANGER
                        }));
                    default:
                        return (this.toaster.show({
                            message: 'An error occurred. Please try again later.',
                            intent: Intent.DANGER
                        }));
                }
            })
    }
    handleCloseDialog = () => (this.setState({ modalIsOpen: false }));
    handleOpenDialog = () => (this.setState({ modalIsOpen: true }));

    render() {
        const { modalIsOpen, email } = this.state;

        return (
            <div>
                <Toaster position={Position.TOP_RIGHT} ref={(toaster) => this.toaster = toaster} />
                <Dialog
                    icon="key"
                    title="Reset password"
                    isOpen={modalIsOpen}
                    onClose={this.handleCloseDialog}>
                    <div className={Classes.DIALOG_BODY}>
                        <FormGroup
                            label="Please indiquate your email address"
                            labelFor="recover-email">
                            <InputGroup
                                id="recover-email"
                                onChange={this.handleChangeInput}
                                defaultValue={email}
                                name="email" />
                        </FormGroup>
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button
                                onClick={this.handleCloseDialog}
                                text="Cancer" />
                            <Button
                                onClick={this.handleSubmitRecoverPassword}
                                text="Reset"
                                intent={Intent.PRIMARY} />
                        </div>
                    </div>
                </Dialog>
                <div onClick={this.handleOpenDialog} className='recover-password'>
                    Forgot your password?
                </div>
            </div>
        )
    }
}

export default SignInPanel;